var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0025 4.88347C12.0025 4.03568 11.3154 3.34863 10.4676 3.34863H4.8864C4.03861 3.34863 3.35156 4.03568 3.35156 4.88347V10.4647C3.35156 11.3125 4.03861 11.9995 4.8864 11.9995H10.4676C11.3154 11.9995 12.0025 11.3125 12.0025 10.4647V4.88347ZM11.1653 4.88347V10.4647C11.1653 10.8498 10.8527 11.1623 10.4676 11.1623H4.8864C4.50129 11.1623 4.18875 10.8498 4.18875 10.4647V4.88347C4.18875 4.49836 4.50129 4.18582 4.8864 4.18582H10.4676C10.8527 4.18582 11.1653 4.49836 11.1653 4.88347Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79061 7.01057L1.18936 8.61182C1.30042 8.63749 1.41596 8.65089 1.53483 8.65089H2.79061V7.01057ZM2.9653 4.04527L0 7.01057V7.11605C0 7.5313 0.164646 7.90803 0.432544 8.1843L2.79061 5.82623V4.88357C2.79061 4.58553 2.85312 4.30144 2.9653 4.04527ZM5.82623 0L0 5.82623V4.21996L4.21996 0H5.82623ZM3.03562 0H1.53483C0.687048 0 0 0.687048 0 1.53483V3.03562L3.03562 0ZM4.04527 2.9653C4.30144 2.85312 4.58553 2.79061 4.88357 2.79061H5.82623L8.1843 0.432544C7.90803 0.164646 7.5313 0 7.11605 0H7.01057L4.04527 2.9653ZM7.01057 2.79061H8.65089V1.53483C8.65089 1.41596 8.63749 1.30042 8.61182 1.18936L7.01057 2.79061Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.4da208c2c01eac77dd49eac9a2b785c7.svg";
export { ForwardRef as ReactComponent };